import * as React from "react";
import {useState} from "react";
import {IInsuraceProduct} from "StateInterface";
import {whatIsCoveredEvent} from "insurance/events";
interface IContent {
    description?: string;
    heading?: string;
    image?: string;
}
interface ITabContent {
    tabLabel: string;
    content: IContent[];
}
interface IProps {
    details: ITabContent[];
    productDetails?: IInsuraceProduct;
}

export default function TabContent(props: IProps) {
    const [currentTabIndex, updateCurrentTabIndex] = useState<number>(0);
    const onClickTab = (index: number, label: string) => {
        updateCurrentTabIndex(index);
        whatIsCoveredEvent(props.productDetails.productTitle);
    };
    return(
        <div className="text-center">
            {props.details.map((tabContent, index) => {
                return (
                    <b className={`ml-2 mr-2 ${currentTabIndex === index ? "tab-selected" : ""}`}
                       key={index} onClick={() => onClickTab(index, tabContent.tabLabel)}>
                        {tabContent.tabLabel}
                    </b>
                );
            })}
            <div>
                <ul className="text-left no-list-style p-1">
                    {
                        props.details[currentTabIndex].content.map((contentDetails, index) => {
                            return (
                                <li className="my-3" key={index}>
                                    { contentDetails.hasOwnProperty("image") ? <img src={contentDetails.image} alt="icons " className="insurance-icons"/> : null}
                                    <p className="tab-content-description">
                                        { contentDetails.hasOwnProperty("heading") ?
                                            <b>{contentDetails.heading}</b> : null}
                                        { contentDetails.hasOwnProperty("description") ?
                                            contentDetails.description : null}
                                    </p>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
}
